<template>
  <v-icon color="grey" small>
    mdi-translate
  </v-icon>
</template>

<script>
export default {
  name: 'translationIcon'
}
</script>
